import { createSlice } from '@reduxjs/toolkit';

import { Connection } from 'entities/Connection';
import { AppError } from 'entities/Errors';

import { getConnectionList } from './connection.action';

interface ConnectionState {
  loading: boolean;
  error: null | AppError;
  connections: Connection[];
}

const initialState = {
  loading: false,
  error: null,
  connections: [],
} as ConnectionState;

export const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getConnectionList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getConnectionList.fulfilled, (state, action) => {
        state.loading = false;
        state.connections = action.payload.data;
      })
      .addCase(getConnectionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default connectionSlice.reducer;
